import { alpha, styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import baseTheme from "../themes/baseTheme";
import { NumericFormat } from "react-number-format";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField, Stack } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { format, parse } from "date-fns";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    border: `1px solid ${baseTheme.palette.grey[40]}`,
    fontSize: "0.9rem",
    padding: "0.4rem 0.6rem",
    "&:focus": {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}));

export default function ({
  defaultValue,
  placeholder,
  width = "300px",
  handleChange,
  handleBlur,
  type,
  min,
  max,
  required,
  handleKeyDown,
  ISTRUE,
  ...props
}) {
  const handleDateChange = (date) => {
    handleChange({ target: { value: date.format('MM/DD/YYYY') } });
  };

  // const formatDateValue = (value) => {
  //   if (!value) return "";
  //   return format(parse(value, "yyyy-MM-dd", new Date()), "MM/dd/yyyy");
  // };
  function checkValue(value) {
    // First, check if the value is a valid number
    if (!isNaN(value)) {
      let numberValue = parseFloat(value);  // Convert the string to a number
      // Check if the number has decimals
      if (!Number.isInteger(numberValue)) {
        return parseFloat(value).toFixed(2);
      } else {
        return value;
      }
    } else {
      return value;
    }
  }
  
  return type === "number" ? (
    <>
    <NumericFormat
      className="mb-2 text-input"
    
      value={props?.value ?? ""}
      placeholder={placeholder}
      sx={{ width: width }}
      thousandSeparator
      customInput={BootstrapInput}
      decimalSeparator="."
      decimalScale={2}  // restrict to 2 decimal places
      fixedDecimalScale={true}
      onKeyDown={handleKeyDown}
      onChange={(e, value) => {
        handleChange(e);
      }}
      {...props}
    />
    </>
  ) : type === "label" ? (
    <div style={{ width: ISTRUE ? width : "" }}>
      <span style={{ wordWrap: "break-word" }}> {props.value}</span>
    </div>
  ) : type === "date" ? (
    // <DatePicker
    //   selected={props?.value ? new Date(props.value) : null}
    //   onChange={handleDateChange}
    //   dateFormat="MM/dd/yyyy"
    //   customInput={
    //     <TextField
    //       className="mb-2 text-input"
    //       placeholder={placeholder}
    //       sx={{ width: width }}
    //       onBlur={handleBlur}
    //       onKeyDown={handleKeyDown}
    //       InputLabelProps={{ shrink: true }}
    //       inputProps={{
    //         min: min,
    //         max: max,
    //       }}
    //       InputProps={{
    //         endAdornment: (
    //           <InputAdornment position="end">
    //             <IconButton>
    //               <CalendarMonthIcon />
    //             </IconButton>
    //           </InputAdornment>
    //         ),
    //       }}
    //       {...props}
    //     />
    //   }
    // />
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      views={["year", "month", "day"]}
      value={props?.value ? new Date(props.value) : null}
      onChange={handleDateChange}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={{
            "& legend": { display: "none" },
            "& fieldset": { top: 0 },
            width: width 
          }}
          size="small"
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
        />
      )}
    />
  </LocalizationProvider>
  ) : (
    <BootstrapInput
      className="mb-2 text-input"
      type={type}
      defaultValue={defaultValue || ""}
      placeholder={placeholder}
      sx={{ width }}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      {...props}
    />
  );
}
